import { DataSeriesLite } from './DataSeriesLite';
import { DataFrame, ColumnarData, ColumnVal } from './DataFrame';
import { DataPrimitive, DataType, IDataFrame } from './DataPrimitive';

/**
 * Base DataFrame class and associated DataFrame selectors
 * @implements {DataPrimitive}
 */
export class DataFrameLite<T extends DataType = DataType>
    extends DataFrame
    implements IDataFrame<DataType>, DataPrimitive<T>
{
    /**
     * Loads ColumnarData into a DataFrame
     * DataFrame contains DataSeries but without DataPoints
     * @param {ColumnarData} columnarData
     * @param {boolean} enableTagSearchResult If true, tag DataPoints from datasource with isSearchResult
     * @returns {DataFrame<T>}
     */
    static fromJsonCols<ColType extends DataType = DataType>(
        columnarData: ColumnarData,
        enableTagSearchResult?: boolean
    ): DataFrame<ColType> {
        if (!columnarData?.data) {
            return new DataFrame<ColType>([]);
        }
        const {
            data: { fields = [], columns = [] },
        } = columnarData;
        if (columns.length !== fields.length) {
            throw new Error(
                `number of columns (${columns.length}) does not match number of fields (${fields.length})`
            );
        }
        const dataSeries = [];
        columns.forEach((data: ColumnVal[], idx): void => {
            const fieldInfo: any = fields[idx];
            const field: string = fieldInfo.name || fieldInfo;
            const type: string = fieldInfo?.type;
            const series = new DataSeriesLite(data, type, field);
            // Store enableTagSearchResult flag on the series for later use when DataPoints are created
            if (enableTagSearchResult) {
                (series as any).enableTagSearchResult = enableTagSearchResult;
            }
            dataSeries.push(series);
        });
        return new DataFrame<ColType>(dataSeries);
    }
}
